import { render, staticRenderFns } from "./FishDivider.vue?vue&type=template&id=36c761ae&scoped=true&"
import script from "./FishDivider.vue?vue&type=script&lang=js&"
export * from "./FishDivider.vue?vue&type=script&lang=js&"
import style0 from "./FishDivider.vue?vue&type=style&index=0&id=36c761ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c761ae",
  null
  
)

export default component.exports